// extracted by mini-css-extract-plugin
export default {"hideTooltip":"E_-z","fadeIn":"F_-z","delay":"G_-z","recommendedSizeTooltip":"H_-z"};